import React, { memo } from 'react';
import renderValue from '../../../../components/formBuilder/utility/renderValue';
import classNames from '../../../../utility/classNames';
import Tooltip from '../../../../components/Tooltip';
import { formatLargeNumber } from '../../../../utility/formatNumbers';
import FormUIOptions from '../../../../components/formBuilder/formElements/formUIOptions';
import { isValue } from '../../../../utility/isValue';

const ProjectionRow = memo(function ProjectionRow({
  field,
  data,
  mainField,
  isDropdownOpen,
  cols,
  labelClasses,
  width,
}) {
  //dynamic -> field styling is dynamic depending on if the value is positive or negative
  const {
    layout = 'default',
    type,
    label,
    name,
    altName,
    description,
    formula,
    emphasize,
    fontNormal,
    groupEnd = false,
    dynamic = false,
    total,
    small,
  } = field;

  return (
    <div
      className={classNames(
        'px-2 sm:px-0',
        (layout === 'compact' || layout === 'tableNoLabel') && 'my-0 space-y-0',
        'w-full',
        !mainField ? '' : isDropdownOpen && fontNormal ? '' : 'font-semibold',
        emphasize && 'font-semibold',
        groupEnd && 'pb-5'
      )}
    >
      <div className={classNames(cols)}>
        {layout !== 'tableNoLabel' && (
          <div
            className={classNames(
              labelClasses,
              mainField ? 'sm:col-span-2' : 'sm:col-span-1'
            )}
          >
            <div
              className={classNames(
                'z-30 inline',
                total && 'mt-1.5 mb-0.5',
                `rounded-sm rounded-r-none bg-neutral-500 sm:bg-transparent px-2 text-white sm:text-black`
              )}
            >
              {label}{' '}
              {description && <Tooltip type="info" text={description} />}
            </div>
          </div>
        )}

        {data.map((year, index) => {
          const fieldValue = isValue(year[name]) ? year[name] : year[altName];

          return (
            <div key={year.year + index} className="w-full">
              {total && (
                <hr
                  className={classNames(
                    '-mt-1 sm:mt-0.5 sm:mb-0.5 border border-neutral-300',
                    (index !== 0 || index !== data.length - 1) &&
                      '-mx-8 sm:-mx-2'
                  )}
                />
              )}
              <div
                className={classNames(
                  'relative w-full sm:max-w-xs h-full flex items-center px-1 pt-6 pb-4 sm:py-0',
                  total && 'pt-9',
                  type !== FormUIOptions.Money && '-mr-3 sm:-mr-0',
                  formula
                    ? 'justify-end gap-1 sm:justify-between'
                    : mainField
                    ? 'justify-center'
                    : 'justify-end',
                  dynamic && fieldValue < 0 && 'text-red-700',
                  dynamic && fieldValue > 0 && 'text-green-700',
                  small && 'text-base'
                )}
              >
                {(width > 640 || type !== FormUIOptions.Money) &&
                  renderValue(field, { [name]: fieldValue })}
                {width <= 640 &&
                  type === FormUIOptions.Money &&
                  formatLargeNumber(fieldValue, field)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default ProjectionRow;
